(function() {
  var isAddingBundle = false;

  function formatMoney(cents) {
    if (window.theme && theme.Currency && theme.settings) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }

    return (cents / 100).toFixed(2);
  }

  function toNumber(value, fallback) {
    var number = parseInt(value, 10);

    if (isNaN(number)) {
      return fallback || 0;
    }

    return number;
  }

  function setText(el, text) {
    if (!el) {
      return;
    }

    el.textContent = text || '';
    el.classList.toggle('hide', !text);
  }

  function getCopy(bundle, key, isSelected) {
    var state = isSelected ? 'active' : 'inactive';
    var fallbackState = isSelected ? 'inactive' : 'active';
    var attr = 'data-bundle-' + state + '-' + key;
    var fallbackAttr = 'data-bundle-' + fallbackState + '-' + key;

    if (bundle.hasAttribute(attr)) {
      return bundle.getAttribute(attr) || '';
    }

    return bundle.getAttribute(fallbackAttr) || '';
  }

  function isBundleSelected(bundle) {
    var toggle = bundle.querySelector('[data-bundle-toggle]');

    return !toggle || toggle.checked;
  }

  function getProductForm(bundle) {
    var productBlocks = bundle.closest('[data-product-blocks]');
    var productSection = bundle.closest('.product-section');
    var form = productBlocks ? productBlocks.querySelector('.product-single__form') : null;

    if (!form && productSection) {
      form = productSection.querySelector('.product-single__form');
    }

    return form;
  }

  function getCheckoutUrl() {
    var rootUrl = window.theme && theme.routes && theme.routes.home ? theme.routes.home : '/';

    if (rootUrl.slice(-1) !== '/') {
      rootUrl += '/';
    }

    return rootUrl + 'checkout';
  }

  function getSelectedBundleOption(bundle) {
    var input = bundle.querySelector('[data-bundle-addon-variant-input]:checked');
    var select = bundle.querySelector('[data-bundle-variant-select]');

    if (input) {
      return input;
    }

    if (!select) {
      return null;
    }

    return select.options[select.selectedIndex] || null;
  }

  function syncSelectedBundleVariant(bundle) {
    var selectedOption = getSelectedBundleOption(bundle);
    var addonPriceText = bundle.querySelector('[data-bundle-addon-price-text]');
    var addonVariantText = bundle.querySelector('[data-bundle-addon-variant]');

    if (selectedOption) {
      bundle.dataset.bundleVariantId = selectedOption.value;
      bundle.dataset.bundleVariantPrice = selectedOption.dataset.price || '0';
      bundle.dataset.bundleVariantTitle = selectedOption.dataset.title || selectedOption.textContent.trim();
    }

    if (addonPriceText) {
      addonPriceText.innerHTML = formatMoney(toNumber(bundle.dataset.bundleVariantPrice));
    }

    if (addonVariantText) {
      var title = bundle.dataset.bundleVariantTitle || '';

      if (title === 'Default Title') {
        title = '';
      }

      addonVariantText.textContent = title;
      addonVariantText.classList.toggle('hide', !title);
    }
  }

  function setProductMenuExpanded(bundle, expanded) {
    var trigger = bundle.querySelector('[data-bundle-product-menu-trigger]');
    var menu = bundle.querySelector('[data-bundle-product-menu]');

    if (!trigger || !menu) {
      return;
    }

    trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    menu.hidden = !expanded;
    document.documentElement.classList.toggle('bundle-upsell-modal-open', expanded);

    if (expanded) {
      var selectedOption = menu.querySelector('[data-bundle-product-option].is-selected');
      var closeButton = menu.querySelector('[data-bundle-product-menu-close]');
      var focusTarget = selectedOption || closeButton || menu;

      window.setTimeout(function() {
        focusTarget.focus();
      }, 0);
    } else if (menu.contains(document.activeElement)) {
      trigger.focus();
    }
  }

  function selectAddonProduct(bundle, optionButton) {
    var variantTemplate = document.getElementById(optionButton.dataset.variantTemplateId);
    var variantSelect = bundle.querySelector('[data-bundle-variant-select]');
    var titleEl = bundle.querySelector('[data-bundle-addon-title]');
    var image = bundle.querySelector('[data-bundle-addon-image]');
    var imageWrap = bundle.querySelector('[data-bundle-addon-image-wrap]');
    var optionButtons = bundle.querySelectorAll('[data-bundle-product-option]');
    var selectedLabel = bundle.dataset.bundleProductSelectedLabel || 'Valittu';
    var selectLabel = bundle.dataset.bundleProductSelectLabel || 'Valitse';

    bundle.dataset.bundleProductId = optionButton.dataset.productId || '';
    bundle.dataset.bundleProductTitle = optionButton.dataset.productTitle || '';

    if (titleEl) {
      titleEl.textContent = bundle.dataset.bundleProductTitle;
    }

    if (image) {
      if (optionButton.dataset.productImageSrc) {
        image.src = optionButton.dataset.productImageSrc;
        image.alt = optionButton.dataset.productImageAlt || bundle.dataset.bundleProductTitle;
        image.classList.remove('hide');

        if (imageWrap) {
          imageWrap.classList.remove('hide');
        }
      } else {
        image.removeAttribute('src');
        image.alt = '';
        image.classList.add('hide');
      }
    }

    if (variantSelect && variantTemplate) {
      variantSelect.innerHTML = variantTemplate.innerHTML;
    }

    optionButtons.forEach(function(button) {
      var isSelected = button === optionButton;
      var status = button.querySelector('[data-bundle-product-option-status]');

      button.classList.toggle('is-selected', isSelected);
      button.setAttribute('aria-pressed', isSelected ? 'true' : 'false');

      if (status) {
        status.textContent = isSelected ? selectedLabel : selectLabel;
      }
    });

    syncSelectedBundleVariant(bundle);
    syncBundleState(bundle);
    setProductMenuExpanded(bundle, false);
  }

  function syncDynamicCheckout(bundle) {
    var form = getProductForm(bundle);
    var paymentButtons = form ? form.querySelector('.shopify-payment-button') : null;

    if (paymentButtons) {
      paymentButtons.classList.toggle('hide', isBundleSelected(bundle));
    }
  }

  function syncAddToCartButton(bundle) {
    var form = getProductForm(bundle);
    var addToCart = form ? form.querySelector('[data-add-to-cart]') : null;
    var addToCartText = form ? form.querySelector('[data-add-to-cart-text]') : null;
    var selected = isBundleSelected(bundle);
    var checkoutText = bundle.dataset.bundleCheckoutButtonText || 'Siirry kassalle';

    if (!addToCart || !addToCartText) {
      return;
    }

    if (!addToCartText.dataset.bundleDefaultText) {
      addToCartText.dataset.bundleDefaultText = addToCartText.textContent.trim();
    }

    if (selected && !addToCart.disabled) {
      addToCartText.textContent = checkoutText;
      addToCart.setAttribute('data-bundle-checkout-active', 'true');
      return;
    }

    addToCart.removeAttribute('data-bundle-checkout-active');

    if (!addToCart.disabled) {
      addToCartText.textContent = addToCartText.dataset.bundleDefaultText || addToCartText.dataset.defaultText || '';
    }
  }

  function hideNativeVariantPicker(bundle) {
    var productSection = bundle.closest('.product-section');
    var productBlocks = bundle.closest('[data-product-blocks]');
    var nativePicker = productBlocks ? productBlocks.querySelector('.bundle-upsell-native-variant-picker') : null;
    var variantWrapper = null;

    if (!nativePicker && productSection) {
      nativePicker = productSection.querySelector('.bundle-upsell-native-variant-picker');
    }

    if (!nativePicker && productBlocks) {
      variantWrapper = productBlocks.querySelector('.variant-wrapper');
      nativePicker = variantWrapper ? variantWrapper.closest('.product-block') : null;
    }

    if (!nativePicker || nativePicker.contains(bundle)) {
      return;
    }

    nativePicker.classList.add('bundle-upsell-native-variant-picker');
    nativePicker.style.display = 'none';
    nativePicker.setAttribute('aria-hidden', 'true');
    nativePicker.setAttribute('data-bundle-hidden-variant-picker', '');
  }

  function syncBundleCopy(bundle) {
    var selected = isBundleSelected(bundle);

    setText(bundle.querySelector('[data-bundle-heading]'), getCopy(bundle, 'heading', selected));
    setText(bundle.querySelector('[data-bundle-text]'), getCopy(bundle, 'text', selected));
    setText(bundle.querySelector('[data-bundle-total-label]'), getCopy(bundle, 'total-label', selected));
  }

  function syncBundlePrices(bundle) {
    var selected = isBundleSelected(bundle);
    var currentPrice = toNumber(bundle.dataset.bundleCurrentPrice);
    var addonPrice = toNumber(bundle.dataset.bundleVariantPrice);
    var discount = toNumber(bundle.dataset.bundleDiscount, 20);
    var originalTotal = selected ? currentPrice + addonPrice : currentPrice;
    var discountedTotal = selected ? Math.round(originalTotal * (100 - discount) / 100) : currentPrice;
    var savings = selected ? originalTotal - discountedTotal : 0;
    var currentPriceEl = bundle.querySelector('[data-bundle-current-price-text]');
    var originalPriceEl = bundle.querySelector('[data-bundle-original-price]');
    var discountPriceEl = bundle.querySelector('[data-bundle-discount-price]');
    var savingsEl = bundle.querySelector('[data-bundle-savings]');

    if (currentPriceEl) {
      currentPriceEl.innerHTML = formatMoney(currentPrice);
    }

    if (originalPriceEl) {
      originalPriceEl.innerHTML = formatMoney(originalTotal);
      originalPriceEl.classList.toggle('hide', !selected);
    }

    if (discountPriceEl) {
      discountPriceEl.innerHTML = formatMoney(discountedTotal);
    }

    if (savingsEl) {
      savingsEl.innerHTML = (savingsEl.dataset.bundleSavingLabel || '') + ' ' + formatMoney(savings);
      savingsEl.classList.toggle('hide', !selected);
    }
  }

  function syncBundleState(bundle) {
    var selected = isBundleSelected(bundle);
    var variantInputs = bundle.querySelectorAll('[data-bundle-variant-select], [data-bundle-addon-variant-input]');

    syncSelectedBundleVariant(bundle);
    syncBundleCopy(bundle);
    syncBundlePrices(bundle);
    syncDynamicCheckout(bundle);
    syncAddToCartButton(bundle);

    bundle.classList.toggle('bundle-upsell--inactive', !selected);
    variantInputs.forEach(function(input) {
      input.disabled = !selected || input.dataset.originalDisabled === 'true';
    });
  }

  function syncThemeVariantInputs(bundle, selectedInput) {
    var productSection = bundle.closest('.product-section');
    var form = productSection ? productSection.querySelector('.product-single__form') : null;
    var masterSelect = form ? form.querySelector('[data-product-select]') : null;
    var lastChangedInput = null;

    if (masterSelect) {
      masterSelect.value = selectedInput.value;
      masterSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }

    if (!productSection) {
      return;
    }

    ['option1', 'option2', 'option3'].forEach(function(optionKey) {
      var value = selectedInput.dataset[optionKey];

      if (!value) {
        return;
      }

      var optionInputs = productSection.querySelectorAll('[data-variant-input][data-index="' + optionKey + '"]');

      optionInputs.forEach(function(optionInput) {
        if (optionInput.tagName === 'SELECT') {
          optionInput.value = value;
          lastChangedInput = optionInput;
        } else if (optionInput.value === value) {
          optionInput.checked = true;
          lastChangedInput = optionInput;
        }
      });
    });

    if (lastChangedInput) {
      lastChangedInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function syncMainVariantChoice(bundle, selectedInput) {
    var currentVariantEl = bundle.querySelector('[data-bundle-current-variant]');
    var variantTitle = selectedInput.dataset.title || '';

    bundle.dataset.bundleCurrentPrice = selectedInput.dataset.price || '0';

    if (variantTitle === 'Default Title') {
      variantTitle = '';
    }

    if (currentVariantEl) {
      currentVariantEl.textContent = variantTitle;
      currentVariantEl.classList.toggle('hide', !variantTitle);
    }

    syncThemeVariantInputs(bundle, selectedInput);
    syncBundleState(bundle);
  }

  function updateMainVariant(bundle, variant) {
    if (!variant) {
      return;
    }

    var currentVariantEl = bundle.querySelector('[data-bundle-current-variant]');
    var mainVariantInput = bundle.querySelector('[data-bundle-main-variant-input][value="' + variant.id + '"]');
    var mainVariantSelect = bundle.querySelector('[data-bundle-main-variant-select]');
    var variantTitle = variant.public_title || variant.title || '';

    bundle.dataset.bundleCurrentPrice = variant.price || 0;

    if (variantTitle === 'Default Title') {
      variantTitle = '';
    }

    if (currentVariantEl) {
      currentVariantEl.textContent = variantTitle;
      currentVariantEl.classList.toggle('hide', !variantTitle);
    }

    if (mainVariantInput) {
      mainVariantInput.checked = true;
    }

    if (mainVariantSelect) {
      mainVariantSelect.value = variant.id;
    }

    syncBundleState(bundle);
  }

  function getBundleForForm(form) {
    var productBlocks = form.closest('[data-product-blocks]');
    var productSection = form.closest('.product-section');
    var bundle = productBlocks ? productBlocks.querySelector('[data-bundle-upsell]') : null;

    if (!bundle && productSection) {
      bundle = productSection.querySelector('[data-bundle-upsell]');
    }

    if (!bundle || !isBundleSelected(bundle)) {
      return null;
    }

    syncSelectedBundleVariant(bundle);

    if (!bundle.dataset.bundleVariantId) {
      return null;
    }

    var selectedOption = getSelectedBundleOption(bundle);

    if (selectedOption && selectedOption.disabled) {
      return null;
    }

    return bundle;
  }

  function getLineItemProperties(formData, extraProperties) {
    var properties = {};

    formData.forEach(function(value, key) {
      var match = key.match(/^properties\[(.+)\]$/);

      if (match && value !== '') {
        properties[match[1]] = value;
      }
    });

    Object.keys(extraProperties).forEach(function(key) {
      properties[key] = extraProperties[key];
    });

    return properties;
  }

  function buildBundleItems(form, bundle) {
    var formData = new FormData(form);
    var mainVariantId = formData.get('id');
    var bundleVariantId = bundle.dataset.bundleVariantId;
    var quantity = parseInt(formData.get('quantity'), 10) || 1;
    var bundleGroup = 'bundle-' + Date.now();
    var sharedProperties = {
      _bundle: 'Treeni + ravinto-ohjelma',
      _bundle_group: bundleGroup,
      _bundle_discount: '20%'
    };

    if (!mainVariantId || !bundleVariantId) {
      return null;
    }

    var mainItem = {
      id: Number(mainVariantId),
      quantity: quantity,
      properties: getLineItemProperties(formData, Object.assign({}, sharedProperties, {
        _bundle_role: 'main'
      }))
    };

    var sellingPlan = formData.get('selling_plan');

    if (sellingPlan) {
      mainItem.selling_plan = Number(sellingPlan);
    }

    return [
      mainItem,
      {
        id: Number(bundleVariantId),
        quantity: quantity,
        properties: Object.assign({}, sharedProperties, {
          _bundle_role: 'addon'
        })
      }
    ];
  }

  function showError(form, error) {
    var errors = form.querySelector('.errors');
    var message = error && error.description ? error.description : 'Tuotteita ei voitu lis\u00e4t\u00e4 ostoskoriin.';

    if (errors) {
      errors.remove();
    }

    if (typeof message === 'object') {
      message = error.message;
    }

    errors = document.createElement('div');
    errors.classList.add('errors', 'text-center');
    errors.textContent = message;
    form.append(errors);

    form.dispatchEvent(new CustomEvent('ajaxProduct:error', {
      detail: {
        errorMessage: message
      },
      bubbles: true
    }));
  }

  function handleBundleSubmit(evt) {
    var form = evt.target;

    if (!form || !form.classList || !form.classList.contains('product-single__form')) {
      return;
    }

    var bundle = getBundleForForm(form);

    if (!bundle) {
      return;
    }

    evt.preventDefault();
    evt.stopImmediatePropagation();

    if (isAddingBundle) {
      return;
    }

    var items = buildBundleItems(form, bundle);
    var addToCart = form.querySelector('[data-add-to-cart]');

    if (!items) {
      return;
    }

    isAddingBundle = true;

    if (addToCart) {
      addToCart.classList.add('btn--loading');
    }

    fetch(theme.routes.cartAdd, {
      method: 'POST',
      body: JSON.stringify({ items: items }),
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then(function(response) {
        return response.json().then(function(data) {
          return {
            ok: response.ok,
            data: data
          };
        });
      })
      .then(function(response) {
        if (!response.ok || response.data.status === 422) {
          showError(form, response.data);
          return;
        }

        var errors = form.querySelector('.errors');

        if (errors) {
          errors.remove();
        }

        window.location.href = getCheckoutUrl();
      })
      .catch(function(error) {
        showError(form, error);
      })
      .finally(function() {
        isAddingBundle = false;

        if (addToCart) {
          addToCart.classList.remove('btn--loading');
        }
      });
  }

  function initBundle(bundle) {
    if (bundle.dataset.bundleInitialized === 'true') {
      return;
    }

    var productSection = bundle.closest('.product-section');
    var toggle = bundle.querySelector('[data-bundle-toggle]');
    var variantInputs = bundle.querySelectorAll('[data-bundle-variant-select], [data-bundle-addon-variant-input]');
    var mainVariantInputs = bundle.querySelectorAll('[data-bundle-main-variant-input]');
    var mainVariantSelect = bundle.querySelector('[data-bundle-main-variant-select]');
    var productMenuTrigger = bundle.querySelector('[data-bundle-product-menu-trigger]');
    var productMenu = bundle.querySelector('[data-bundle-product-menu]');
    var productMenuClose = bundle.querySelector('[data-bundle-product-menu-close]');
    var productOptions = bundle.querySelectorAll('[data-bundle-product-option]');

    bundle.dataset.bundleInitialized = 'true';
    hideNativeVariantPicker(bundle);

    variantInputs.forEach(function(input) {
      input.dataset.originalDisabled = input.disabled ? 'true' : 'false';
      input.addEventListener('change', function() {
        syncBundleState(bundle);
      });
    });

    mainVariantInputs.forEach(function(input) {
      input.dataset.originalDisabled = input.disabled ? 'true' : 'false';
      input.addEventListener('change', function() {
        if (input.checked) {
          syncMainVariantChoice(bundle, input);
        }
      });
    });

    if (mainVariantSelect) {
      mainVariantSelect.addEventListener('change', function() {
        var selectedOption = mainVariantSelect.options[mainVariantSelect.selectedIndex];

        if (selectedOption && !selectedOption.disabled) {
          syncMainVariantChoice(bundle, selectedOption);
        }
      });
    }

    if (productMenuTrigger) {
      productMenuTrigger.addEventListener('click', function() {
        setProductMenuExpanded(bundle, productMenuTrigger.getAttribute('aria-expanded') !== 'true');
      });
    }

    if (productMenuClose) {
      productMenuClose.addEventListener('click', function() {
        setProductMenuExpanded(bundle, false);
      });
    }

    if (productMenu) {
      productMenu.addEventListener('click', function(evt) {
        if (evt.target === productMenu) {
          setProductMenuExpanded(bundle, false);
        }
      });

      productMenu.addEventListener('keydown', function(evt) {
        if (evt.key === 'Escape') {
          setProductMenuExpanded(bundle, false);
        }
      });
    }

    productOptions.forEach(function(optionButton) {
      optionButton.addEventListener('click', function() {
        selectAddonProduct(bundle, optionButton);
      });
    });

    if (productSection) {
      productSection.addEventListener('variantChange', function(evt) {
        updateMainVariant(bundle, evt.detail.variant);
      });
    }

    if (toggle) {
      toggle.addEventListener('change', function() {
        syncBundleState(bundle);
      });
    }

    syncBundleState(bundle);
  }

  function initBundles(context) {
    var root = context || document;

    root.querySelectorAll('[data-bundle-upsell]').forEach(initBundle);
  }

  document.addEventListener('submit', handleBundleSubmit, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initBundles(document);
    });
  } else {
    initBundles(document);
  }

  document.addEventListener('shopify:section:load', function(evt) {
    initBundles(evt.target);
  });

  document.addEventListener('quickview:loaded', function() {
    initBundles(document);
  });
})();
